export default __webpack_public_path__ + "6bede58e856278b0f8f1ddf5aceb2e96.ttf";